<template>
  <div
    class="invite-register"
    :style="{backgroundImage: 'url('+bgImg+')', backgroundSize:'cover',backgroundRepeat: 'no-repeat'}"
  >
    <div class="login-mobile">
      <div class="login-title">{{ mapLoginType[loginType] }}</div>
      <!-- 手机注册 -->
      <div v-if="loginType == 2" class="app-login" style="width:308px">
        <el-form ref="form2" :model="form2" :rules="rules0">
          <el-form-item prop="mobile">
            <el-input v-model="form2.mobile" placeholder="请输入手机号码" />
          </el-form-item>
          <el-form-item prop="mobileAuthCode">
            <el-row type="flex" justify="space-between" :gutter="10">
              <el-col>
                <el-input
                  v-model="form2.mobileAuthCode"
                  maxlength="6"
                  placeholder="请输入验证码"
                  @keyup.enter.native="login2"
                />
              </el-col>
              <el-col style="flex:1">
                <el-button
                  type="primary"
                  class="sms-btn"
                  :disabled="smsButtonDisable || !form2.mobile"
                  @click="getVerification"
                >{{ smsSecond > 0 ? smsSecond + 'S' : '获取验证码' }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button
              class="special_btn"
              type="primary"
              style="width:100%;"
              :disabled="login2ButtonDisabled"
              @click="login2"
            >注册领红包</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 设置密码弹窗 -->
      <Dialog
        v-if="setpasswordDialogVisible"
        custom-class="set-psw"
        :show.sync="setpasswordDialogVisible"
        top="30px"
        width="620px"
      >
        <el-form
          ref="formsetpassword"
          :model="formsetpassword"
          :rules="rules0"
          @submit.native.prevent
        >
          <p>设置登录密码</p>
          <el-form-item prop="password">
            <el-input
              v-model="formsetpassword.password"
              type="password"
              placeholder="请设置密码"
              @keyup.enter.native="loginSetPassword"
            />
            <!-- <div style="line-height:18px;margin-top:5px">
              请使用字母、数字和特殊字符两种及以上组合
              <br />且在6-20个字符之间
            </div>-->
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width:100%"
              :disabled="!formsetpassword.password.length"
              @click="loginSetPassword"
            >设置密码</el-button>
          </el-form-item>
        </el-form>
      </Dialog>

      <!-- 用户协议 -->
      <div class="login-copyright">
        <!-- <p class="login-copyright" > -->
        <p :class="{'check-icon': isAgree }" @click="useAgree"></p>
        <span>我已经阅读并同意&nbsp;&nbsp;</span>
        <span @click="useAgreeModal" class="regist">《云游戏用户协议》</span>
      </div>
    </div>
    <div
      class="top_url"
      :style="{backgroundImage: 'url('+ top_url+')', backgroundPosition: 'center center',backgroundSize:'cover',backgroundRepeat: 'no-repeat'}"
    ></div>
    <div
      class="bottom_url"
      :style="{backgroundImage: 'url('+bottom_url+')',backgroundPosition: 'center center', backgroundSize:'cover',backgroundRepeat: 'no-repeat'}"
    ></div>
    <div v-if="agreeDialog">
      <Dialog
        v-if="agreeDialog"
        custom-class="choose-agree-dialog"
        :show.sync="agreeDialog"
        top="30px"
        :width="setOWidth"
      >
        <useAgree @close="agreeDialog =false" />
        <div class="footer" style="margin-top:40px">
          <!-- <Button @click="submitShortOrderInfo">确定</Button> -->
          <span @click="agreeDialog=false">不同意</span>
          <span @click="agree()">已阅读并同意</span>
        </div>
      </Dialog>
    </div>

    <!-- 获得积分提示 -->
    <Dialog v-if="integral" custom-class="integral" :show.sync="integral" top="30px" width="620px">
      <p>恭喜获得50积分</p>
      <p>注册奖励已发送至您的账户中</p>
      <img src="~assets/img/inivite.png" alt />
      <p>
        <span>+50</span>积分
      </p>
      <p @click="integral=false;">知道啦～</p>
    </Dialog>
    <!-- 领取积分提示 -->
    <Dialog v-if="receive" custom-class="integral" :show.sync="receive" top="30px" width="620px">
      <p>该手机号已领取奖励</p>
      <p>前往客户端分享专属链接获得更多奖励</p>
      <img class="success" src="~assets/img/inviteRegister/success.png" alt />
      <div class="btn" @click="receive=false;$router.push('/user')">知道啦～</div>
    </Dialog>
    <p v-if="agreeDialog" class="backshow" @click="goBack"></p>
    <p v-if="setpasswordDialogVisible" class="backshow_psw" @click="setpasswordDialogVisible=false"></p>
  </div>
</template>

<script>
import rules from "@/utils/rules";
import Base64 from "@/utils/decode";
import useAgree from "views/Settings/userAgree";
// import { LoginImages } from '@/utils/images'
export default {
  name: "inviteRegister",
  components: {
    useAgree
  },
  data() {
    return {
      setOWidth: "1100px",
      selectIndex: 1,
      loginType: 2,
      forgetPasswordStep: 1,
      LoginImages: {
        // switchClose: require('assets/img/login/unagree.png'),
        // switchOpen: require('assets/img/login/remember_psw.png')
        //
      },
      login2ButtonDisabled: true,
      // login2ButtonDisabled: false,
      smsButtonDisable: false,
      setpasswordDialogVisible: false,
      mapLoginType: {
        1: "登录",
        2: "注册领红包",
        3: "重置登录密码",
        4: "重置密码"
      },
      // forgetPsw: true,
      // forgetPasswordNextButtonDisabled: true,
      // forgetPasswordSmsButtonDisable: false,
      form2: {
        mobile: "",
        mobileAuthCode: ""
      },
      form1: {
        mobile: "",
        password: ""
      },
      isSavePwd: false,
      forgetPasswordForm1: {
        mobile: "",
        mobileAuthCode: ""
      },
      forgetPasswordForm2: {
        mobile: "",
        acccessAuthCode: "",
        password: ""
      },

      formsetpassword: {
        acccessAuthCode: "",
        password: "",
        mobile: ""
      },
      rules0: rules,
      smsSecond: 0,
      isRegister: "",
      imgurl: window.VUE_STATIC_RES_URL,
      bgImg: "",
      bottom_url: "",
      top_url: "",
      isAgree: false,
      agreeDialog: false,
      qqloginVisible: false,
      integral: false,
      receive: false,
      inviteCode: null,
      showApp: false
      /* 小棕瓶 634 ，古驰403 176, 纪梵希粉饼 221 ，散粉 228，黄油 148，流金水234 白泥 185，mac986 156 */
    };
  },
  mounted() {
    // this.$toast("短信已发送!");
    this.top_url = `${this.imgurl}images/inviteRegister/desc.png`;
    if (localStorage.getItem("pwd")) {
      this.isSavePwd = true;
      this.form1.password = Base64.decode(localStorage.getItem("pwd"));
      this.form1.mobile = Base64.decode(localStorage.getItem("phone"));
    }
    // this.screenFirst();
    this.inviteCode = this.GetQueryString("inviteCode");
    const that = this;
    window.onresize = function() {
      that.oWidth();
      console.log($(window).height());
      $(".invite-register").css({
        height: $(window).height() + "px"
      });
    };
    this.oWidth();
    $(".invite-register").css({
      height: $(window).height() + "px"
    });
  },
  beforeDestory() {
    clearInterval(this.smsTimer);
  },
  methods: {
    /* 判断宽度 */
    oWidth() {
      if ($(window).width() < 1000) {
        $(".invite-register").css({
          backgroundColor: "#202E40",
          backgroundSize: "contain",
          backgroundPosition: "center top"
        });
        $(".bottom_url").css({
          height: "260px"
        });
        this.bgImg = `${this.imgurl}images/inviteRegister/app_bg_top.png`;
        this.bottom_url = `${this.imgurl}images/inviteRegister/app_bg_bottom.png`;
        this.setOWidth = "80%";
      } else {
        this.bgImg = `${this.imgurl}images/inviteRegister/pc_bg_top.png`;
        this.bottom_url = `${this.imgurl}images/inviteRegister/pc_bg_bottom.png`;
        $(".invite-register").css({
          backgroundPosition: "center center"
        });
        this.setOWidth = "1100px";
      }
    },
    goBack() {
      this.agreeDialog = false;
    },
    /* 计算高度 */
    screenFirst() {
      let wH = $(window).height();
      let screenH = $(".invite-register").height();

      if (screenH < 1008) {
        $(".invite-register").css({
          height: wH + "px"
        });
      } else {
        $(".invite-register").css({
          height: "1080px"
        });
      }
    },
    /* 用户协议选择 */
    useAgree() {
      this.isAgree = !this.isAgree;
      if (this.isAgree) this.$store.commit("setAgree", 1);
    },
    /* 用户协议 */
    useAgreeModal() {
      this.agreeDialog = true;
      // this.$router.push("/userAgree");
    },
    agree() {
      this.isAgree = true;
      this.agreeDialog = false;
      this.$store.commit("setAgree", 1);
    },

    /* 获取验证码 */
    async getVerification() {
      this.$refs.form2.validateField("mobile", msg => {
        if (msg === "") {
          const res = this.$http.login_send_sms(this.form2);
          this.login2ButtonDisabled = false;
          this.smsSecond = 60;
          this.smsButtonDisable = true;
          this.smsTimer = setInterval(() => {
            this.smsSecond = this.smsSecond - 1;
            if (this.smsSecond <= 0) {
              this.smsButtonDisable = false;
              clearInterval(this.smsTimer);
            }
          }, 1000);
          this.$toast("短信已发送!");
        }
      });
    },
    initForgetForm() {
      this.forgetPasswordStep = 1;
      this.forgetPasswordForm1 = {
        mobile: "",
        mobileAuthCode: ""
      };
      this.form2 = {
        mobile: "",
        mobileAuthCode: ""
      };
      this.forgetPasswordForm2 = {
        mobile: "",
        acccessAuthCode: "",
        password: ""
      };
      this.$refs.form2.clearValidate();
      this.$refs.forgetPasswordForm1.clearValidate();
      this.$refs.forgetPasswordForm2.clearValidate();
    },
    resetPassword() {
      this.$refs.forgetPasswordForm2.validate(valid => {
        this.forgetPasswordForm2.mobile = this.forgetPasswordForm1.mobile;
        if (valid) {
          if (
            this.forgetPasswordForm2.password !==
            this.forgetPasswordForm2.password2
          ) {
            this.$toast("两次密码输入不一致！");
            return;
          }
          this.$http.reset_password(this.forgetPasswordForm2).then(res => {
            this.$toast("重置密码成功,请重新登录");
            this.initForgetForm();
            this.loginType = 2;
            this.smsSecond = -1;
          });
        } else {
          return false;
        }
      });
    },
    loginSetPassword() {
      this.$refs.formsetpassword.validate(valid => {
        if (valid) {
          this.formsetpassword.inviteCode = this.inviteCode;

          this.$http.set_password(this.formsetpassword).then(res => {
            if (res.code == 0) {
              res.data.special = 1;
              this.setpasswordDialogVisible = false;
              this.integral = true;
              setTimeout(() => {
                this.integral = false;
                this.$store.dispatch("handleLoginSuccess", res.data);
              }, 2000);
            }
          });
        } else {
          return false;
        }
      });
    },
    login2() {
      this.$refs.form2.validate(valid => {
        this.form2.loginType = this.loginType;
        if (valid) {
          this.login(this.form2, false);
        } else {
          return false;
        }
      });
    },
    login(form, isPwdLogin) {
      // if(isRegister == 1 || this.isRegister ==1 || this.isSavePwd)
      if (this.loginType == 2 && this.isAgree)
        this.$http.complex_login(form).then(
          res => {
            if (res.data.hasPassword && res.data.hasPassword === "0") {
              // 说明是新用户需要设置密码
              this.setpasswordDialogVisible = true;
              this.formsetpassword.acccessAuthCode = res.data.acccessAuthCode;
              this.formsetpassword.mobile = this.form2.mobile;
            } else {
              if (this.isSavePwd) {
                if (isPwdLogin) {
                  localStorage.setItem("pwd", Base64.encode(form.password));
                  localStorage.setItem("phone", Base64.encode(form.mobile));
                }
              } else {
                localStorage.removeItem("pwd");
                localStorage.removeItem("phone");
              }
              this.receive = true;
              // setTimeout(() => {
              //   this.integral = false;
              //   this.receive = false;

              // }, 1000);
              // this.$store.dispatch("handleLoginSuccess", res.data);
            }
          },
          error => {
            console.log(error);
          }
        );
      else this.$toast("请选择用户协议");
    },
    changeLoginType(loginType) {
      // this.loginTitle = '重置登录密码';
      // this.forgetPsw = false;
      this.loginType = loginType;
      if (loginType == 1) {
        this.$store.commit("setAgree", 1);
      }
    },
    /* //获取地址栏参数 */
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
  }
};
</script>


<style lang="scss">
.invite-register {
  overflow: hidden;
  // padding-top: 90px;
  position: relative;
  @include size();
  * {
    color: rgba(221, 221, 221, 1);
    font-size: 14px;
  }

  .show-box {
    position: relative;
  }
  .card-login-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    width: 300px;
    span {
      cursor: pointer;
      &:hover {
        cursor: pointer;
        color: #65dfec;
      }
    }
  }
  .login-copyright {
    // width: 270px;
    text-align: center;
    height: 23px;
    p {
      display: inline-block;
      @include size(21px, 22px);
      background: url("~assets/img/inviteRegister/no-select.png") no-repeat;
      vertical-align: middle;
      margin-right: 5px;
      cursor: pointer;
      &:hover {
        background: url("~assets/img/inviteRegister/no-hover.png") no-repeat;
      }
      &:active {
        background: url("~assets/img/inviteRegister/no-active.png") no-repeat;
      }
      &.check-icon {
        background: url("~assets/img/inviteRegister/select.png") no-repeat;
        &:hover {
          background: url("~assets/img/inviteRegister/hover.png") no-repeat;
        }
        &:active {
          background: url("~assets/img/inviteRegister/active.png") no-repeat;
        }
      }
    }

    span {
      font-size: 14px;
      &:nth-of-type(2) {
        cursor: pointer;
      }
    }
  }
  .login-mobile {
    * {
      color: #ddd;
    }
    position: absolute;
    top: 43%;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 100;
    @include size(620px, 394px);
    background: #3b4f65;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .login-title {
      padding: 63px 0 24px 0;
      font-size: 18px;
      font-weight: 500;
      color: rgba(221, 221, 221, 1);
    }
    .el-input .el-input__inner,
    .el-button {
      border-radius: 30px !important;
    }
    .el-input__inner {
      background: rgba(170, 217, 249, 0.25);
      color: #ddd;
      border-color: transparent;
      height: 40px;
      line-height: 40px;
      opacity: 1;
      &:hover {
        border: 2px solid rgba(238, 238, 238, 0.6);
      }
      &:active {
        opacity: 0.6;
      }
    }
    .el-button {
      background: rgba(170, 217, 249, 0.25);
      border-color: transparent;
      height: 40px;
      // line-height: 43px;
      &:hover {
        background: #31abda;
      }
      &:active {
        background: rgba(170, 217, 249, 0.15);
      }
    }

    .is-disabled {
      background: rgba(170, 217, 249, 0.25);
      span {
        opacity: 0.6;
      }
    }
    .special_btn {
      background: rgba(170, 217, 249, 0.25);
      opacity: 1;
      span {
        opacity: 1;
      }
    }
    .el-form-item {
      margin-bottom: 24px;
    }
    .el-form-item__error {
      color: #ff3b00;
    }
    .el-form-item.is-error .el-input__inner,
    .el-form-item.is-error .el-input__inner:focus,
    .el-form-item.is-error .el-textarea__inner,
    .el-form-item.is-error .el-textarea__inner:focus,
    .el-message-box__input input.invalid,
    .el-message-box__input input.invalid:focus {
      border-color: #ff3b00;
    }
    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
      background: rgba(170, 217, 249, 0.3);
    }
    .sms-btn {
      font-size: 14px;
      width: 108px;
      &:hover {
        background: #31abda;
      }
      &:active {
        background: rgba(170, 217, 249, 0.15);
      }
    }
    .save-pwd-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      width: 78px;
      height: 43px;
      padding: 0 15px;
      border-radius: 30px;
      line-height: 43px;
      background: rgba(170, 217, 249, 0.2);
      border-color: transparent;
      cursor: pointer;
    }
  }
  .top_url {
    height: 126px;
    width: 600px;
    position: absolute;
    // top: 310px;
    top: 33%;

    left: 0;
    right: 0;
    margin: auto;
    margin-top: -63px;
  }
  .bottom_url {
    height: 121px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    // background-color: #202e40;
  }
  .regist {
    text-decoration: underline;
    &:hover {
      color: #31abda;
    }
    &:active {
      opacity: 0.6;
    }
  }
  .backshow {
    @include size(38px, 38px);
    position: fixed;
    cursor: pointer;
    left: 50%;
    bottom: 75px;
    margin-left: -19px;
    background: url("~assets/img/inviteRegister/back.png");
    z-index: 3000;
    &:hover {
      background: url("~assets/img/inviteRegister/back_hover.png");
    }
    &:active {
      background: url("~assets/img/inviteRegister/back_active.png");
    }
  }
  .backshow_psw {
    @extend .backshow;
    bottom: 220px;
    // margin-top: 220px;
  }
}
.choose-agree-dialog {
  background: #3B4F65;
  margin-top: -35px !important;

  .footer {
    padding-bottom: 40px;
    text-align: center;
    span {
      display: inline-block;
      @include size(170px, 45px);
      line-height: 45px;
      border-radius: 28px;
      font-size: 16px;
      margin: 0 35px;
      text-align: center;
      cursor: pointer;

      background: rgba(170, 217, 249, 0.2);
      &:hover {
        background: #31abda;
      }
      &:active {
        background: rgba(170, 217, 249, 0.15);
      }
      &:nth-of-type(2) {
        background: rgba(170, 217, 249, 0.35);
        &:hover {
          background: #31abda;
        }
        &:active {
          background: rgba(170, 217, 249, 0.15);
        }
      }
    }
  }
}
.set-psw {
  p {
    font-size: 20px;
    text-align: center;
    padding: 80px 0 67px 0;
  }
  .el-form-item {
    width: 308px;

    margin: 0 auto;
  }
  .el-input__inner {
    border-color: transparent;
    height: 40px;

    background: rgba(170, 217, 249, 0.25);
    &:hover {
      border: 2px solid rgba(238, 238, 238, 0.6);
    }
    &:active {
      opacity: 0.6;
    }
  }
  .el-button {
    margin-top: 67px;
    height: 40px;
    line-height: 40px;
    background: rgba(170, 217, 249, 0.2);
    border-color: transparent;
    padding: 0;
    span {
      color: #ddd;
    }
    &:hover {
      background: #31abda;
      border-color: transparent;
    }
    &:active {
      background: rgba(170, 217, 249, 0.15);
      border-color: transparent;
    }
    .is-disabled {
      background: rgba(170, 217, 249, 0.2);
      span {
        opacity: 0.6;
      }
      color: rgba($color: #ddd, $alpha: 0.6);
      border-color: transparent;
    }
  }
}
.integral {
  height: 394px;
  background: #3B4F65;
  .success{
    margin:59px auto;
    margin-top:47px ;
  }
  p {
    text-align: center;
    &:nth-of-type(1) {
      font-size: 20px;
      font-weight: 500;
      color: #eeeeee;
      line-height: 20px;
      letter-spacing: 2px;
      padding: 40px 0 16px 0;
    }
    &:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
      color: #eeeeee;
      line-height: 21px;
      letter-spacing: 1px;
      padding-bottom: 12px;
    }
    &:nth-of-type(3) {
      span {
        font-size: 22px;
        font-weight: bold;
        color: #ffbb7e;
        margin-right: 4px;
      }
      color: #ffbb7e;
      padding-bottom: 8px;
    }
    &:nth-of-type(4) {
      width: 308px;
      height: 40px;
      line-height: 40px;
      background: rgba(170, 217, 249, 0.2);
      border-radius: 29px;
      margin: 24px auto;
      &:hover {
        background: #31abda;
        border-color: transparent;
      }
      &:active {
        background: rgba(170, 217, 249, 0.15);
        border-color: transparent;
      }
      cursor: pointer;
    }
  }
  img {
    @include size(100px, 100px);
    margin: 24px auto;
  }
  .btn {
    @extend p:nth-of-type(4);
    text-align: center;
  }
}
@media screen and (max-height: 900px) {
  .invite-register {
    min-height: 937px;
    overflow: auto;
  }
}
@media screen and (min-height: 1080px) {
  .choose-agree-dialog {
    min-height: 78rem;
    overflow: auto;
    .footer{
      padding: 0 0 4rem 0;
      span {
      display: inline-block;
      @include size(18rem, 5.5rem);
      line-height: 5.5rem;
      border-radius: 5.5rem;
      font-size: 2rem;

      // margin: 0 35px;
      }
    }
  }
}
@media screen and (max-width: 1080px) {
  .invite-register {
    .backshow{
    @include size(4.5rem, 4.5rem);
    position: fixed;
    cursor: pointer;
    // left: 50%;
    bottom: 80px;
    // margin-left: -1.5rem;
    left: 0;
    right: 0;
    margin: auto;
    background: url("~assets/img/inviteRegister/back.png");
    background-size: 100%;
    z-index: 3000;
    &:hover {
      background: url("~assets/img/inviteRegister/back_hover.png");
      background-size: 100%;
    }
    &:active {
      background: url("~assets/img/inviteRegister/back_active.png");
      background-size: 100%;
    }
  }
    .top_url {
      top: 32rem;
      height: 10rem;
      width: 49rem;
    }
    .login-mobile {
      // min-height: 1250px;
      width: 48rem;
      height: 41rem;
      top: 41rem;
      * {
        font-size: 2rem;
      }
      .login-title {
        padding: 3.4rem 0;
        font-size: 2.5rem;
      }
      .app-login {
        width: 40rem !important;
      }
      .el-form-item {
        width: 40rem !important;
        margin: 0 auto;
        margin-bottom: 3rem;
      }
      .el-input .el-input__inner {
        text-indent: 2rem;
      }
      .el-input .el-input__inner,
      .el-button {
        height: 5.5rem;
        border-radius: 6rem !important;
      }
      .sms-btn {
        width: 15rem;
      }
      .login-copyright {
        p {
          width: 2rem;
          height: 2rem;

          display: inline-block;
          background: url("~assets/img/inviteRegister/no-select.png") no-repeat;
          background-size: 100% 100%;
          vertical-align: middle;
          margin-right: 1rem;
          cursor: pointer;
          &:hover {
            background: url("~assets/img/inviteRegister/no-hover.png") no-repeat;
            background-size: 100% 100%;
          }
          &:active {
            background: url("~assets/img/inviteRegister/no-active.png")
              no-repeat;
            background-size: 100% 100%;
          }
          &.check-icon {
            background: url("~assets/img/inviteRegister/select.png") no-repeat;
            background-size: 100% 100%;
            &:hover {
              background: url("~assets/img/inviteRegister/hover.png") no-repeat;
              background-size: 100% 100%;
            }
            &:active {
              background: url("~assets/img/inviteRegister/active.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        span {
          font-size: 1.7rem;
        }
      }
    }
  }
  .integral {
    width: 48rem !important;
    height: 42rem;
    p {
      text-align: center;
      &:nth-of-type(1) {
        font-size: 2.5rem;
        font-weight: 500;
        color: #eeeeee;
        // line-height: 20px;
        letter-spacing: 2px;
        padding: 4.5rem 0 3rem 0;
      }
      &:nth-of-type(2) {
        font-size: 1.8rem;
        font-weight: 400;
        color: #eeeeee;
        // line-height: 21px;
        letter-spacing: 0.2rem;
      }
      &:nth-of-type(3) {
        font-size: 1.8rem;
        span {
          font-size: 2.5rem;
          font-weight: bold;
          color: #ffbb7e;
          margin-right: 0.5rem;
        }
        color: #ffbb7e;
      }
      &:nth-of-type(4) {
        width: 40rem !important;
        height: 5.5rem;
        line-height: 5.5rem;
        border-radius: 5.5rem;
        font-size: 2rem;
      }
    }
    img {
      @include size(12rem, 12rem);
      margin: 0 auto;
      margin-top: 4.5rem;
      margin-bottom: 1.2rem;
    }
    .success {
      margin-top: 5rem;
      margin-bottom: 5rem;
    }
    .btn {
      text-align: center;
      border-radius: 5.5rem;
      font-size: 2rem;
      // margin-top: 5rem;
    }
  }
  .el-form-item__error{
    font-size: 1.8rem !important;
    padding-top:1rem;
  }
  .set-psw {
    width: 48rem !important;
    height: 42rem;
    * {
      font-size: 2rem;
    }
    p {
      font-size: 2.5rem;
      text-align: center;
      padding: 5.5rem 0 0 0;

      letter-spacing: 0.4rem;
    }
    .el-form-item {
      width: 40rem !important;

      margin: 0 auto;
      margin:8rem auto ;
    }
    .el-input .el-input__inner,
    .el-button {
      height: 4.5rem;
      border-radius: 4.5rem !important;
    }
    .el-input .el-input__inner{
      text-indent: 2rem;
    }
    .el-button {
      margin-top: 67px;
      height: 4.5rem;
      line-height: 4.5rem;
      border-radius: 4.5rem !important;
    }
  }
  
}
</style>